/* Una tarea que alguien le anotó a otro desde Mis pendientes, y en qué está.
 *
 * Nico, 20/10: «le di una tarea a Ruben y quiero controlarla en el futuro. Y
 * que sólo yo la pueda dar por finalizada». La tarea es UNA fila, que ven los
 * dos (migración 20261020210100):
 *
 *   · `dado_por` — el mail de quien la anotó. Null en las propias y en las
 *     derivadas de Avisos de ruta, que siguen como siempre.
 *   · `lista_en` — el que la recibió dijo «la terminé». No la cierra.
 *   · `hecho`    — en una dada lo pone sólo quien la dio («le dio el OK»).
 *
 * Sin la migración no viene `dado_por`, `dadaPorOtro` da false y todo se ve
 * como hoy: eso es lo que hace que la pantalla ande igual con o sin ella.
 *
 * Acá vive lo que no es dibujo —quién la dio, el estado, el orden, el
 * «desde cuándo»— para probarlo sin montar la pantalla, y en hora argentina
 * pase lo que pase con el reloj de la máquina (`fechaAr`).
 */
import { diaIsoAr, hoyAr } from "./fechaAr";

const minus = (v) => String(v ?? "").trim().toLowerCase();

/* ¿Me la anotó otro? (Vista por el que la tiene en sus pendientes.) */
export function dadaPorOtro(t) {
  const por = minus(t?.dado_por);
  return !!por && por !== minus(t?.dueno);
}

export const PENDIENTE = "pendiente";
export const LISTA = "lista"; // el que la tiene dijo «la terminé»: falta el OK
export const HECHA = "hecha"; // quien la dio le dio el OK

export function estadoDada(t) {
  if (t?.hecho) return HECHA;
  if (t?.lista_en) return LISTA;
  return PENDIENTE;
}

/* «Las que di», en el orden en que se miran: arriba las que esperan mi OK (la
   que me avisaron primero, primero), después las pendientes por antigüedad, y
   aparte las terminadas, la última que cerré arriba. */
export function ordenarDadas(ts) {
  const abiertas = [];
  const terminadas = [];
  for (const t of ts || []) (t.hecho ? terminadas : abiertas).push(t);
  const clave = (t) => (t.lista_en ? `0${t.lista_en}` : `1${t.creado_en || ""}`);
  abiertas.sort((a, b) => clave(a).localeCompare(clave(b)));
  terminadas.sort((a, b) => String(b.hecho_en || "").localeCompare(String(a.hecho_en || "")));
  return { abiertas, terminadas };
}

/* Cuántas esperan mi OK, para el cartel de arriba. */
export const esperanMiOk = (ts) => (ts || []).filter((t) => estadoDada(t) === LISTA).length;

/* «desde hoy», «desde ayer», «desde el 18/10» (con el año si no es este). En
   hora argentina: a las 22:00 AR «hoy» sigue siendo hoy aunque en UTC ya sea
   mañana. */
export function desdeCuando(iso, ahora = new Date()) {
  const dia = diaIsoAr(iso);
  if (!dia) return "";
  const hoy = hoyAr(ahora);
  const ayer = hoyAr(new Date(ahora.getTime() - 24 * 3600 * 1000));
  if (dia === hoy) return "desde hoy";
  if (dia === ayer) return "desde ayer";
  const [a, m, d] = dia.split("-");
  return `desde el ${d}/${m}${a === hoy.slice(0, 4) ? "" : `/${a}`}`;
}

/* El nombre de alguien del hub por su mail, como lo muestra «Para». Sin la
   guía, la parte de antes de la arroba: un mail entero en una lista se lee
   mal y no agrega nada. */
export function nombreDe(mail, gente) {
  const m = minus(mail);
  if (!m) return "";
  const g = (gente || []).find((x) => minus(x.mail) === m);
  return (g && String(g.nombre || "").trim()) || m.split("@")[0];
}

/* Lo que tira la base cuando el que la recibe quiere cerrar, reescribir o
   borrar una que le dio otro (el trigger de la migración). */
export const esSoloQuienLaDio = (e) => /solo_quien_la_dio/.test(String(e?.message || e || ""));
